module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-580-32a01264658c625444933aee25094ae4.jpg";